<template>
  <nav class="team-rail" :aria-label="`Roles on this ${noun}`">
    <a
      v-for="section in sections"
      :key="section.id"
      :href="`#${section.id}`"
      class="rail-item"
      :class="{ active: section.id === active }"
      :aria-current="section.id === active ? 'location' : undefined"
      @click.prevent="emit('select', section.id)"
    >
      <Text variant="label-medium" color="inherit">{{ section.label }}</Text>
      <Text v-if="section.count !== undefined" variant="label-small" :color="section.count ? 'secondary' : 'tertiary'">
        {{ section.count || '—' }}
      </Text>
    </a>

    <div v-if="note" class="rail-note">
      <Text variant="body-small" color="tertiary">{{ note }}</Text>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { Text } from '@tallo/design-system';

import { TeamRailSection } from './team-roles';

defineProps<{ sections: TeamRailSection[]; noun: string; active?: string; note?: string }>();
const emit = defineEmits<{ select: [sectionId: string] }>();
</script>

<style scoped lang="scss">
.team-rail {
  position: sticky;
  top: var(--t-spacing-md);
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.rail-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  border-radius: var(--t-border-radius-sm);
  color: var(--t-color-neutral-800);
  text-decoration: none;
  transition:
    background-color 150ms var(--t-ease-in-out),
    color 150ms var(--t-ease-in-out);

  &:hover,
  &.active {
    color: var(--t-text-color-primary);
  }

  &.active {
    background-color: var(--t-color-neutral-white);
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px var(--t-color-neutral-950);
  }
}

.rail-note {
  margin: 0.75rem 0.75rem 0;
  padding-top: 0.75rem;
  border-top: 1px solid var(--t-color-border-secondary);
}
</style>
